// Mirrors backend utils/pr-service-fields.prLineValues: quantity and unit price
// always come from the line; Service Qty / Service Unit Price are reference only.
export function prLineValues(_requisitionType: unknown, line: any): { quantity: number; unitPrice: number; amount: number } {
  const quantity = Number(line?.quantity || 0)
  const unitPrice = Number(line?.unitprice || 0)
  return { quantity, unitPrice, amount: quantity * unitPrice }
}
